import React, { useEffect } from 'react';
import * as CONSTANTS from '../../utils/CONSTANTS';
import { makeSideBarActive } from '../../utils/EllowUtils';
import SideMenu from "../sideMenu";
import DashboardHeader from "../topbar";
import { useState } from 'react';
import Styles from "./styles.module.scss";
import MyWorkplaceUsersTab from './myWorkplaceUsersTab';
import { TabStrip, TabStripSelectEventArguments } from "@progress/kendo-react-layout";
import Tab from '../../components/tab';
import { getAllocatedto, getCandidates } from './services';
import { viewedpageMixpanel } from '../../utils/mixpanel';

function MyWorkplaceUsers() {
  const menu = makeSideBarActive(CONSTANTS.sideMenu, 2)
  const BreadcrumsValues = ["Myworkplace users"]

  const [filterValues, setFilterValues] = useState<any>(null)
  const [companyName, setCompanyName] = useState<any>()
  const [registeredData, setRegisteredData] = useState<any>()
  const [allocatedTo, setAllocatedTo] = useState<any>()
  const [registeredTotal, setRegisteredTotal] = useState<any>()
  const [basicProfileData, setBasicProfileData] = useState<any>()
  const [basicProfileTotal, setBasicProfileTotal] = useState<number>()
  const [selectedTab, setSelectedTab] = useState<number>(0);
  const [sort, setSort] = useState<any>([]);

  useEffect(() => {
    
    getAllResources('registered', 25, 1, '', '', '')
    getAllResources('basicProfileSubmitted',25, 1, '', '', '')
    getAllocation();
    viewedpageMixpanel();

  
  }, [])

  const getAllocation = () => {
    getAllocatedto().then((response) => {
      if (response && response.status === 1) {
        setAllocatedTo(
          response.data.map((item: any) => {
            return item.name;
          })
        );
      }
    });
  };

  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelectedTab(e.selected)
    
  }
  const getAllResources = ( tabName: string, pageSize: any, pageNumber: number, searchValue: string, filters?: any, sort?: any) => {
     
    let body: any = {};
    if (!filters) {
      body = {
        filters: {
        },
        sort: {
          sortBy: sort && sort.length > 0 ? sort[0].field : '',
          sortOrder: sort && sort.length > 0 ? sort[0].dir : '' 
      }
      }
    }
    else {
      body = {
        filters,
        sort: {
          sortBy: sort && sort.length > 0 ? sort[0].field : '',
          sortOrder: sort && sort.length > 0 ? sort[0].dir : '' 
      }
      }
    }


    getCandidates(tabName, pageSize, pageNumber, searchValue, body).then((response: any) => {
      switch (tabName) {
        case 'registered':
          setRegisteredData(response.data)
          setRegisteredTotal(response.count)
          break
        case 'basicProfileSubmitted':
          setBasicProfileData(response.data)
          setBasicProfileTotal(response.count)
      }
      
      
    })
  }
  
  const searchChange = (e: string) => {
    getAllResources('registered',25, 1, e, '', sort)
    getAllResources('basicProfileSubmitted', 25, 1, e, '', sort)

  }
  
  
  const closeTag = (data: any) => {
    let value = {
      filters: data
    }
      applyFilter(value);
    
  }

  const applySort = (sort: any) => {
  
    getAllResources('registered', 25, 1, '', '', sort)
    getAllResources('basicProfileSubmitted',25, 1, '', '', sort)

  }

  const applyFilter = (data: any) => {

    setFilterValues(data.filters)
    getAllResources('registered', 25, 1, '', data.filters, sort)
    getAllResources('basicProfileSubmitted',25, 1, '', data.filters, sort)  }

  const pageChange = (pageSize: number, pageNumber: number) => {
    let page = pageNumber !== 0 ? Math.floor(pageNumber / pageSize) + 1 : 1; 

    getAllResources('registered', pageSize, page, '')
    getAllResources('basicProfileSubmitted', pageSize, page, '')

  }
  const RegisteredTab = <>Registered <i>{registeredTotal}</i></>
  const BasicProfileTab = <>Basic Profile Submitted <i>{basicProfileTotal}</i></>

  return (
    <section className="dashboardWrapper">
      <SideMenu menu={menu} openresource={'myWorkplaceUsers'} />
      <div className="dashboardContent">
        <DashboardHeader
          title={BreadcrumsValues}
          applyResourceFilter={applyFilter}
          searchChange={searchChange}
          closeTag={closeTag}
          navigateTo="../createResources"
          filterValues={filterValues}
          companyName={companyName}
          type='resources'
          allocatedTo={allocatedTo}
          
        />
        <section className={Styles.dashboardWrapper}>
          <TabStrip selected={selectedTab} onSelect={handleSelect}>
          <Tab title={RegisteredTab} >
              <MyWorkplaceUsersTab data={registeredData} total={registeredTotal} pageSize={pageChange} getTablesValues={() => getAllResources('registered', 25, 1, '')} setSort={setSort} applySort={applySort} />
            </Tab>
            <Tab title={BasicProfileTab} >
          <MyWorkplaceUsersTab data={basicProfileData} total={basicProfileTotal} pageSize={pageChange} getTablesValues={() =>getAllResources('Basicprofile Submitted', 25, 1, '')} setSort={setSort} applySort={applySort}/>
              </Tab>
        </TabStrip>

      </section>
      </div>
    </section>
  )
}

export default MyWorkplaceUsers